import React, { useContext, useEffect, useState } from "react";
import PagePreview from "./Preview";
import { useSelector } from "react-redux";
import { FullGridContext } from "..";
import { getData } from "~/functions/gridFunctions";
import PageContainer from "~/components/PageContainer";
import api from "~/services/api";

const surveyScopes = {
  class: {
    label: "Class Survey",
    endpoint: "surveys-questions",
    inactivateEndpoint: "surveys-questions-inactivate",
  },
  enrollment: {
    label: "Enrollment Survey",
    endpoint: "surveyenrollment-questions",
    inactivateEndpoint: "surveyenrollment-questions-inactivate",
  },
};

export default function SurveysConfiguration() {
  const [selected, setSelected] = useState([]);
  const [scope, setScope] = useState("class");
  const filial = useSelector((state) => state.auth.filial);
  const defaultOrderBy = { column: "created_at", asc: true };
  const activeScope = surveyScopes[scope];
  const defaultGridHeader = [
    {
      title: "Description",
      name: "description",
      type: "text",
      filter: false,
    },
    {
      title: "Type",
      name: "type",
      type: "text",
      filter: true,
    },
    {
      title: "Is Active",
      name: "is_active",
      type: "boolean",
      filter: false,
    },
  ];

  const {
    accessModule,
    activeFilters,
    gridData,
    gridDetails,
    gridHeader,
    handleFilters,
    handleOpened,
    limit,
    loadingData,
    opened,
    orderBy,
    page,
    pages,
    search,
    setActiveFilters,
    setGridData,
    setGridDetails,
    setGridHeader,
    setLimit,
    setLoadingData,
    setOpened,
    setOrderBy,
    setPage,
    setPages,
    setSearch,
    setTotalRows,
    setSuccessfullyUpdated,
    successfullyUpdated,
    totalRows,
  } = useContext(FullGridContext);

  const pageAccess = accessModule.children.find(
    (el) => el.alias === "surveys-configuration"
  );

  async function loader() {
    setLoadingData(true);
    const data = await getData(activeScope.endpoint, {
      limit,
      page,
      orderBy,
      setPages,
      setGridData,
      search,
      defaultGridHeader,
      defaultOrderBy,
      setGridDetails,
    });

    if (!data) {
      setGridData([]);
      setLoadingData(false);
      return;
    }
    const gridDataValues = data.map(
      ({ id, description, type, is_active, canceled_at }, index) => {
        const ret = {
          show: true,
          id,
          fields: [description, type, is_active],
          selectable: !canceled_at && is_active,
          canceled: canceled_at || !is_active,
          page: Math.ceil((index + 1) / limit),
        };
        return ret;
      }
    );
    setGridData(gridDataValues);
    setLoadingData(false);
  }

  async function handleInactivate() {
    if (selected) {
      await api.put(`/${activeScope.inactivateEndpoint}/${selected[0].id}`);
      setSelected([]);
      loader();
    }
  }

  const selectionFunctions = [];
  if (selected) {
    selectionFunctions.push({
      title: "Inactivate",
      alias: "inactivate",
      fun: handleInactivate,
      icon: "X",
      Page: null,
      opened: null,
      setOpened: () => null,
      selected,
    });
  }

  useEffect(() => {
    setSelected([]);
    loader();
  }, [opened, filial, orderBy, search, limit, page, scope]);

  const headerContent = (
    <div className="flex flex-row items-center gap-2 px-2 pt-2">
      {Object.entries(surveyScopes).map(([key, value]) => (
        <button
          key={key}
          type="button"
          onClick={() => setScope(key)}
          className={`border py-2 px-4 text-xs rounded-md transition-all ${
            scope === key
              ? "bg-primary text-white border-primary"
              : "bg-white text-gray-600 hover:border-primary hover:text-primary"
          }`}
        >
          {value.label}
        </button>
      ))}
    </div>
  );

  return (
    <PageContainer
      FullGridContext={FullGridContext}
      PagePreview={PagePreview}
      pageAccess={pageAccess}
      defaultGridHeader={defaultGridHeader}
      headerContent={headerContent}
      extraPreviewProps={{ endpoint: activeScope.endpoint }}
      selection={{
        multiple: false,
        selected,
        setSelected,
        functions: selectionFunctions,
      }}
    />
  );
}
